export const NoteState = {
  ERROR: 0,
  PROGRESS: 1,
  INDEFINITE: 2,
  COMPLETE: 3,
  INFO: 4,
};



// WEBPACK FOOTER //
// ./src/js/system/enums/NoteState.js